import useLazyOpen from './useLazyOpen';

export default useLazyOpen;